import { appConfig } from '@/app.config';
import { getColorPalette } from '@/utils/color';
import storage from '@/utils/storage';

const el = document.documentElement;

/** Init theme settings */
export function initThemeSettings() {
  const color_scheme = [
    'primary',
    'success',
    'warning',
    'danger',
    'error',
    'info',
  ];
  const color_index = [3, 5, 7, 8, 9];
  /** 變更element-plus 色系 */
  color_scheme.forEach((color) => {
    console.log(color);
    const hex = getComputedStyle(el).getPropertyValue(`--app-${color}`);
    el.style.setProperty(`--el-color-${color}-dark-2`, getColorPalette(hex, 8));
    color_index.forEach((index, i) => {
      el.style.setProperty(
        `--el-color-${color}-light-${index}`,
        getColorPalette(hex, 5 - i)
      );
    });
  });

  const settings = {
    ...appConfig,
    themeColor: storage.get('themeColor') || appConfig.themeColor,
  };
  el.style.setProperty(
    '--el-color-primary',
    getColorPalette(settings.themeColor, 6)
  );
  el.style.setProperty(
    '--app-primary',
    getColorPalette(settings.themeColor, 6)
  );
  el.style.setProperty(
    '--app-primary-hover',
    getColorPalette(settings.themeColor, 5)
  );
  el.style.setProperty(
    '--app-primary-active',
    getColorPalette(settings.themeColor, 7)
  );
  return settings;
}

/**
 * @description: 變更主題顏色
 * @param {string} color
 * @param {string} defaultThemeColor
 */
export const changeThemeColors = (color, defaultThemeColor) => {
  if (!color) {
    color = defaultThemeColor;
  }
  storage.set('themeColor', getColorPalette(color, 6));
  el.style.setProperty('--el-color-primary', getColorPalette(color, 6));
  el.style.setProperty('--app-primary', getColorPalette(color, 6));
  el.style.setProperty('--app-primary-hover', getColorPalette(color, 5));
  el.style.setProperty('--app-primary-active', getColorPalette(color, 7));
};
